var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-full w-2 h-2 mr-3 ml-1",class:{
		'bg-red-400': _vm.error,
		'bg-green-400': !_vm.error,
	}})}
var staticRenderFns = []

export { render, staticRenderFns }